import {InviteeParticipantRole} from 'types';

import {removeItem, setItem, getItem} from './Storage';

const STORAGE_KEYS = {
    [InviteeParticipantRole.Client]: 'ezs-client-token',
    [InviteeParticipantRole.Guest]: 'ezs-guest-token',
};

let currentRole: InviteeParticipantRole;

// Used to not allow opening in multiple tabs
let localToken = null;

const init = (role?: InviteeParticipantRole) => {
    currentRole = role || InviteeParticipantRole.Client;
};

const getKey = () => STORAGE_KEYS[currentRole];

const get = (): string | null => localToken || getItem(getKey());

const set = (token: string) => {
    localToken = token;
    setItem(getKey(), token);
};

const remove = () => {
    localToken = null;
    removeItem(getKey());
};

const has = () => !!get();

export const InviteeToken = {init, get, set, remove, has};
